import { render, staticRenderFns } from "./searchComponent.vue?vue&type=template&id=8e0aaa64"
import script from "./searchComponent.vue?vue&type=script&lang=js"
export * from "./searchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerSearch: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerSearch.js').default})
